<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  loading: { type: Boolean, default: false },
  show: { type: Boolean, default: false },
  status: { type: String, default: '' },
});

const emit = defineEmits(['close', 'confirm']);
const { t } = useI18n();

const copy = computed(() => {
  if (props.status === 'concluido') {
    return {
      title: t('REAL_ESTATE_FINANCE.SUGGESTION.COMPLETED.TITLE'),
      description: t('REAL_ESTATE_FINANCE.SUGGESTION.COMPLETED.DESCRIPTION'),
    };
  }

  return {
    title: t('REAL_ESTATE_FINANCE.SUGGESTION.PAID.TITLE'),
    description: t('REAL_ESTATE_FINANCE.SUGGESTION.PAID.DESCRIPTION'),
  };
});
</script>

<template>
  <aside
    v-show="show && status"
    class="fixed inset-x-3 bottom-3 z-50 rounded-lais border border-lais-border bg-white p-4 shadow-lais-pop sm:inset-x-auto sm:right-5 sm:w-[28rem]"
    role="status"
    aria-live="polite"
  >
    <p class="font-semibold text-lais-text">{{ copy.title }}</p>
    <p class="mt-1 text-sm text-lais-text-muted">{{ copy.description }}</p>
    <div class="mt-4 flex flex-wrap justify-end gap-2">
      <LaisPrimaryButton size="sm" variant="ghost" @click="emit('close')">
        {{ t('REAL_ESTATE_FINANCE.SUGGESTION.STAY') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        size="sm"
        :is-loading="loading"
        @click="emit('confirm', status)"
      >
        {{ t('REAL_ESTATE_FINANCE.SUGGESTION.CONFIRM') }}
      </LaisPrimaryButton>
    </div>
  </aside>
</template>
